export const exit = {
	name: 'exit',
	title: 'Leave Site',
	content:
		'<path d="M0.75 12.004L16.5 12.004" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M12.75 15.754L16.5 12.004 12.75 8.254" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M3.306,16.6a10.5,10.5,0,1,0,.179-9.542" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path>',
};
